import type {
  TCurrentPlan,
  TInvoiceCustomer,
  TBillingHistoryItem,
} from '@/types/subscription';

import { useMemo } from 'react';

import EmptyState from '@/components/EmptyState';
import { useFormatText } from '@/hooks/useFormatText';
import BillingHistoryTable from '@/pages/common/settingTabs/subscription/BillingHistoryTable';
import CurrentPlanCard from '@/pages/common/settingTabs/subscription/CurrentPlanCard';
import useUser from '@/store/useUser';

const ParentSubscription = () => {
  const { formatText } = useFormatText();
  const user = useUser((state) => state.user);

  const currentPlan: TCurrentPlan | null = null;
  const billingHistory: TBillingHistoryItem[] = [];

  const customer: TInvoiceCustomer = useMemo(
    () => ({
      name: user.name || '-',
      email: user.email || '-',
    }),
    [user.email, user.name]
  );

  if (!currentPlan) {
    return (
      <div className="max-w-216 w-full" data-testid="parent-subscription">
        <EmptyState
          title={formatText('settings.subscription.no-active-plan-title')}
          description={formatText(
            'settings.subscription.no-active-plan-description'
          )}
        />
      </div>
    );
  }

  return (
    <div className="max-w-216 w-full" data-testid="parent-subscription">
      <h2 className="text-xl font-semibold text-neutral-primary leading-7 tracking-tight">
        {formatText('settings.subscription.billing-plan')}
      </h2>

      <CurrentPlanCard currentPlan={currentPlan} />

      <BillingHistoryTable
        billingHistory={billingHistory}
        customer={customer}
        viewOnly
      />
    </div>
  );
};

export default ParentSubscription;
